// SPDX-License-Identifier: AGPL-3.0-or-later

import GameActivityStore from '@app/features/game_activity/state/GameActivityStore';
import DesktopGameActivityBridge from '@app/features/game_activity/utils/DesktopGameActivityBridge';
import type {GatewayRolloutPayload} from '@app/features/gateway/types/GatewayRolloutTypes';
import TypingChannelFocus from '@app/features/typing/state/TypingChannelFocus';
import VoiceChannelInterest from '@app/features/voice/state/VoiceChannelInterest';

export function handleGatewayRolloutUpdate(data: GatewayRolloutPayload): void {
	GameActivityStore.handleRollout(data);
	TypingChannelFocus.handleRollout(data);
	VoiceChannelInterest.handleRollout(data);
	void DesktopGameActivityBridge.syncPolicy();
}
